import React, { useEffect, useState } from 'react';
import assetPreloader from '../utils/AssetPreloader';
import '../styles/AssetLoader.css'

const AssetLoader = ({ assets, onComplete, children }) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const loadAssets = async () => {
      try {
        await assetPreloader.preloadAssets(assets, (progress) => {
          setProgress(progress);
        });
        setLoading(false);
        if (onComplete) onComplete();
      } catch (error) {
        console.error('Error loading assets:', error);
        setLoading(false);
      }
    };

    loadAssets();
  }, [assets, onComplete]);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-progress">
          <div className="progress-bar" style={{ width: `${progress}%` }} />
        </div>
        <div className="loading-text">Loading... {Math.round(progress)}%</div>
      </div>
    );
  }

  return children;
};

export default AssetLoader;